/**
 * @classdesc Slovak Language Pack
 * @desc This class will used to translate tokens into the Slovak language.
 * @namespace Languages.Slovak
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Slovak
 */
export const dictionary = {
	'years'   : 'Roky',
	'months'  : 'Mesiace',
	'days'    : 'Dni',
	'hours'   : 'Hodiny',
	'minutes' : 'Minúty',
	'seconds' : 'Sekundy'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Slovak
 */
export const aliases = ['sk', 'sk-sk', 'slovak'];
